import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function PrivacyPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>Privacy | OptiSiteSEO</title>
        <meta name="description" content="OptiSiteSEO privacy basics for dev and demo environments." />
        <link rel="canonical" href={canonicalUrl("/privacy")} />
      </Helmet>

      <section className="card section">
        <p className="eyebrow">Privacy</p>
        <h1>How we handle your data</h1>
        <ul className="bullets">
          <li>We scan publicly accessible pages only.</li>
          <li>No login required for the first Free SEO Scan; captcha protects abuse.</li>
          <li>Dev environment scans are for evaluation and testing.</li>
          <li>Contact us for data removal or questions.</li>
        </ul>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
        </div>
      </section>
    </div>
  );
}
